module.exports = __webpack_public_path__ + "img/1726044713073-screenshot-1726044687220.png.9e2ed1e9.webp";